import React from 'react';
import { Link } from 'gatsby';
import ButtonLink from '../../ui/Buttons/ButtonLink';
import { GatsbyImage } from "gatsby-plugin-image";
import * as styles from "./ProductListingView.module.scss";
import classnames from 'classnames';

type Props = {
    item: {
        name: string,
        url: string,
        listenbild: any,
        kurzbeschreibung: string,
    }
}
export default (props: Props) => {
    const { item } = props;

    const path: string = "/produkte/" + item.url;
    
    return (
        <div className={styles.card}>
            <div>
                  <Link to={path}>
                    <figure className="image">
                        {item.listenbild?.src?.childImageSharp?.gatsbyImageData && <GatsbyImage
                            image={item.listenbild.src.childImageSharp.gatsbyImageData}
                            alt={item.listenbild.alt}
                            title={item.listenbild.alt} />}
                    </figure>
                </Link>
            </div>
            <div className={styles.content}>
                <p className={classnames(["title", styles.headline])}>
                    <Link to={path}>
                        {item.name}
                    </Link>
                </p>
                <p className={styles.description}>{item.kurzbeschreibung}</p>
            </div>
            
            <div>
                <ButtonLink className={styles.button} to={path} variation="minimal">zum Produkt</ButtonLink>
            </div>
            
            

            </div>
    );
};